import { AnalyticsPayload, DataObjectArguments } from '@alinta-digital/myaccount-frontend-shared/types/analytics';

declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
  }
}

export function analyticsPush(payload: AnalyticsPayload) {
  if (window.dataLayer) {
    window.dataLayer.push(payload);
  } else {
    console.error('no dataLayer found');
  }
}

export function getAnalyticsEventObject({
  eventName,
  processName,
  processStartDateTime,
  processActionType,
  stepIndex,
  stepDateTime
}: DataObjectArguments): AnalyticsPayload {
  return {
    event: eventName,
    process: {
      name: processName,
      actionType: processActionType,
      processStartDateTime,
      step: {
        index: stepIndex,
        dateTime: stepDateTime
      }
    }
  };
}
